export interface AdminSearchState {
  checkBoxValues: string[];
}

export enum AdminSearchActionTypes {
  UPDATE = '@@admin_search/UPDATE',
}

export interface UpdateAction {
  type: AdminSearchActionTypes.UPDATE;
  payload: AdminSearchState;
}
